import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { DrawerHeader } from 'syf-component-library/ui/atoms';
import { colors, fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H2, Small } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
import Icon from '../icon';
import { FAR_CIRCLE_EXCLAMATION } from '../../const/icon-props';
export const CustomDrawerHeader = styled(DrawerHeader) `
  margin: 12px 24px;
`;
export const CLIHeadingText = styled(H2) `
  font-weight: ${fontWeights.extraBold};
  font-size: ${fontSizes.large}px;

  @media ${query.lessThanSmall} {
    font-size: ${fontSizes.large}px;
  }
`;
export const Text = styled(Body) `
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};

  @media ${query.lessThanSmall} {
    font-size: ${fontSizes.root}px;
  }
`;
export const CenteredContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: auto;
`;
export const ContainerContent = styled.div `
  width: 100%;
  text-align: center;
  max-width: 424px;

  @media ${query.lessThanMedium} {
    width: 90%;
    margin-inline: auto;
  }
`;
export const CustomSmallText = styled(Small) `
  text-align: left;
`;
export const Image = styled.img `
  margin: auto;
  max-height: 112px;
  width: 168px;

  @media ${query.lessThanSmall} {
    max-height: 96px;
    width: 144px;
  }
`;
export const SubTitle = styled(Body) `
  color: ${colors.black};
  font-size: 18px;
  max-width: 600px;
`;
const ErrorWrapper = styled(Inset) `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 1px;
  padding: 0;
`;
export const ErrorIcon = () => (_jsx(ErrorWrapper, { children: _jsx(Icon, { title: "circle error icon", color: colors.error, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }) }));
